/**
 * Resolve a stored file URL against the right origin.
 *
 * An uploaded file's `public_url` is one of two shapes:
 *
 *   `https://…supabase.co/storage/v1/object/public/…`  — an object store, absolute
 *   `/api/v1/public/media/<id>`                        — served by our own API
 *
 * The second must be resolved against the **API** origin, not the page's. In
 * production the bundle is static files on Cloudflare Pages and the API is on
 * Render, so a bare `/api/v1/...` resolves against the Pages domain and is
 * answered with the SPA's own index.html — an <img> pointing at an HTML
 * document, which renders as a broken image with a 200 status. That is the
 * same failure `apiBase.ts` exists to prevent for JSON, and it cannot
 * reproduce in `npm run dev`, where the Vite proxy makes both origins one.
 *
 * Anything else — an absolute URL, or a site-relative path like `/resume.pdf`
 * that belongs to the frontend's own public folder — is returned untouched.
 */

import { API_BASE } from "./apiBase";

/** Paths the API serves. Only these get the API origin prefixed. */
const API_PATH = "/api/";

export function mediaUrl(url: string | null | undefined): string {
  if (!url) return "";
  return url.startsWith(API_PATH) ? `${API_BASE}${url}` : url;
}
